import { useMediaQuery } from 'react-responsive';

import { breakpoints } from '@shared/constants';

export const useResponsive = (breakpoint: keyof typeof breakpoints) => {
    return useMediaQuery({ maxWidth: breakpoints[breakpoint] });
};
